import { render, staticRenderFns } from "./walls.vue?vue&type=template&id=00a4e4c2&scoped=true&"
import script from "./walls.vue?vue&type=script&lang=js&"
export * from "./walls.vue?vue&type=script&lang=js&"
import style0 from "./walls.vue?vue&type=style&index=0&id=00a4e4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4e4c2",
  null
  
)

export default component.exports